import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError, extractDomainError } from "#shared/infra/apiError";

export type UpdateLayout = ClientInferResponseBody<typeof contract.layouts.updateLayout>;

export type UpdateLayoutDto = ClientInferRequest<typeof contract.layouts.updateLayout>["body"];

export const updateLayout = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdateLayoutDto;
}): Promise<UpdateLayout> => {
  const response = await api.layouts.updateLayout.mutation({
    params: {
      id,
    },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  if (response.status === 400) {
    const body = response.body as { message?: string } | undefined;
    throw new ApiError(body?.message ?? "Failed to update Layout", response.status, response.body);
  }

  const domainError = extractDomainError(response.body);
  if (domainError) {
    throw domainError;
  }

  throw new ApiError("Failed to update Layout", response.status, response.body);
};
